<div class="topbar">
  <div class="topbar__logo-container">
    @if (!hideSideBar()) {
      <button class="topbar__hamburger" (click)="onMenuToggle()">
        <i class="pi pi-bars"></i>
      </button>
    }
    <a class="topbar__logo" routerLink="/">
      <plantefeve-logo></plantefeve-logo>
    </a>
  </div>
  @if (hideSideBar()) {
    @for (item of menu(); track i; let i = $index) {
      <button
        class="topbar__orders"
        enterFromClass="topbar__profile-panel--hidden"
        enterActiveClass="animate-scalein"
        leaveToClass="topbar__profile-panel--hidden"
        leaveActiveClass="animate-fadeout"
        igx-menu-item
        [item]="item"
        [index]="i"
        [root]="true"
      ></button>
    }
  }
  <div class="topbar__actions">
    <p-button
      icon="pi pi-user"
      (click)="dropDownMenu.toggle($event)"
      [pTooltip]="'Profiel' | translate"
      tooltipPosition="left"
    ></p-button>
    <p-menu #dropDownMenu [popup]="true" [model]="menuItems()"></p-menu>
  </div>
</div>
